import { useState, useEffect } from "react";
import "./search-input.css";

export function SearchInput({ setSearchInput }) {
  const [display, setDisplay] = useState(false);

  useEffect(() => {
    window.addEventListener("keydown", function (e) {
      if ((e.ctrlKey || e.metaKey) && e.key === "f") {
        e.preventDefault();
        setDisplay(true);
      }
      if (e.key === "Escape") {
        setDisplay(false);
        setSearchInput("");
      }
    });
  }, []);

  return (
    display && (
      <input
        autoFocus
        className="search-input"
        onInput={(e) => setSearchInput(e.target.value)}
      />
    )
  );
}
